<template>
    <div class="col col-xl-2 col-lg-3 col-md-4 col-sm-6 cols-12 motw-modal" @keyup.right="nextModal(book)" @keyup.left="previousModal(book)">
        <b-modal v-model="$store.state.showModal"
                 ref="bookModal"
                 size="lg"
                 no-fade
                 lazy
                 centered
                 @hidden="modalHidden"
                 :title="getModalHeader(book)"
                 header-bg-variant="motwred"
                 footer-bg-variant="motwred"
                 header-text-variant="white"
                 footer-text-variant="white">
            <img :src="coverUrl"
                 class="float-right pr-0 ml-2 mb-2 col-6"></img>

            <div class="key_par">Title:
                <span class="val_par">{{ book.title }}</span>
            </div>

            <div class="key_par">Authors:
                <span v-for="author in book.authors">
                <a href="#"
                   class="motw_table_link"
                   @click="search('authors', author)">{{ author }}</a><span v-text="getEndComma(author)"></span>
                </span>
            </div>

            <div class="key_par" v-if="book.publisher">Publisher:
                <a href="#"
                   class="motw_table_link"
                   @click="search('publisher', book.publisher)">{{ book.publisher }}</a>
            </div>

            <div class="key_par" v-if="book.series">Series:
                <a href="#"
                   class="motw_table_link"
                   @click="search('series', book.series)">{{ book.series }}</a>
            </div>

            <div class="key_par" v-if="book.pubdate">Year:
                <span class="val_par">{{ book.pubdate.slice(0,4) }}</span>
            </div>

            <div class="key_par" v-if="book.formats">Download:
                <span class="val_par" v-html="getFormats(book)"></span>
            </div>

            <div class="key_par" v-if="book.abstract">Abstract:
                <span class="val_par" v-html="cleanHtml(book.abstract)"></span>
            </div>

            <div slot="modal-footer"
                 class="w-100">
                <a href="#"
                   class="float-left motw_table_link librarian_link"
                   @click="search('librarian', book.librarian)" >
                    catalogued by {{ book.librarian }}
                </a>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import sanitizeHtml from "sanitize-html";
    import {
        eventBus
    } from '../main';

    export default {
        props: ['id'],
        data() {
            return {
                coverUrl: 'data:image/gif;base64,R0lGODlhAQABAIABAP///wAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==',
                book: {}
            }
        },
        methods: {
            readableBytes(bytes) {
                var i = Math.floor(Math.log(bytes) / Math.log(1024)),
                    sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

                return (bytes / Math.pow(1024, i)).toFixed(2) * 1 + sizes[i];
            },
            modalHidden() {
                if (this.$store.state.singleBook == true) {
                    this.$store.state.singleBook = false;
                    this.$store.state.searchQuery = {
                        'endpoint': '/books',
                        'status': 'all books'
                    }
                    eventBus.$emit('reloadSearch')
                } else {
                    eventBus.$emit('reloadSearch')
                }
            },
            nextModal(book) {
                eventBus.$emit("nextModal", book._id)
            },
            previousModal(book) {
                eventBus.$emit("previousModal", book._id)
            },
            cleanHtml(html_text) {
                return sanitizeHtml(html_text, {
                    allowedTags: ['a', 'abbr', 'acronym', 'b', 'blockquote', 'code', 'em', 'i', 'li', 'ol', 'ul', 'strong', 'br', 'div', 'p']
                }).replace('**', '');
            },
            getEndComma(author) {
                if (author === this.book.authors[this.book.authors.length - 1]) {
                    return
                } else {
                    return ", "
                }
            },
            getModalHeader(book) {
                if (book.hasOwnProperty('authors') === false) {
                    return
                }
                let authors = book.authors
                if (authors.length > 3) {
                    authors = book.authors.slice(0, 3)
                    authors.push("et al.")
                }
                return `"${book.title}" by ${authors.join(', ')}`
            },
            search(field, query) {
                this.$store.state.searchQuery = {
                    'endpoint': `/search/${field}/${query}`,
                    'status': `${field}: ${query}`
                }
                this.$store.state.singleBook = false;
                this.$refs.bookModal.hide()
            },
            getFormats(book) {
                let f = '';
                for (let frm of book['formats']) {
                    let book_url = book.library_url + frm.dir_path + frm.file_name
                    let size = this.readableBytes(frm.size)
                    let download_stripe = `<a title="${size}" class="motw_table_link" href="${book_url}">.${frm.format}</a>, `;
                    f += download_stripe;
                }
                return f.slice(0, -3)
            },
            getCover(book) {
                if ("cover_url" in book) {
                    if (typeof book.library_url == 'undefined') {
                        book.library_url = "";
                    }
                    return book.library_url + book.cover_url
                }
            },
            loadBook() {
                this.coverUrl = 'data:image/gif;base64,R0lGODlhAQABAIABAP///wAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
                this.$http.get('book/' + this.id)
                    .then(response => {
                        if (response.data == "TRYAGAIN") {
                            setTimeout(function() {
                                eventBus.$emit("loadBook")
                            }, 400);
                        } else {
                            this.book = response.data;
                        }
                    })
                    .then(() => {
                        if ("cover_url" in this.book) {
                            if (typeof this.book.library_url == 'undefined') {
                                this.book.library_url = "";
                            }
                            this.coverUrl = this.book.library_url + this.book.cover_url
                        }
                    })
            },

        },
        watch: {
            id: function(val, oldVal) {
                /* this.$store.state.showModal = true; */
                this.loadBook()
            }
        },
        mounted() {
            this.$store.state.showModal = true;
            this.loadBook()
        },
        created() {
            eventBus.$on('modalHidden', this.modalHidden)
            eventBus.$on('loadBook', this.loadBook)
        }

    }
</script>

<style scoped>
    .col {
        padding-left: 2px;
        padding-right: 2px;
        padding-bottom: 2px;
        padding-top: 2px;
    }

    .card-body {
        padding: 0px;
    }

    .card-text,
    .card-title,
    .card-subtitle {
        font-weight: bold;
        font-size: 1.0em;
        background: black;
        margin: 0px;
        padding-top: 6px;
        padding-right: 3px;
        padding-left: 6px;
    }

    .card-title {
        font-size: 1.2em;
    }

    .card-subtitle {
        font-style: italic;
    }

    .card-text {
        width: 100%;
        position: absolute;
        bottom: 0;
    }

    .key_par {
        font-weight: bold;
        padding-bottom: 0.5em;
    }

    .val_par {
        font-weight: normal;
    }

    .librarian_link {
        color: white;
        font-weight: bold;
    }
</style>



// WEBPACK FOOTER //
// src/components/BookModal.vue